
import Vue from "vue";
import Vuex from "vuex";
import common from "../utils/common/common";
import configServer from "../utils/config-server/config-server";
Vue.use(Vuex);

export default new Vuex.Store({

  state: {
    menuList: [],
    btnList: [],
    toUserCenter: false, // 是否跳转人中心
    // BI
    permissionCity: [],
    areaId: localStorage.areaId || "",
    cityId: "",
    nickname: "",
    uid: "",
    firstAppList: [],
    agentlist: [], //商户列表
    currentAgent: {}, //当前选择商户
    useHelpPage:[] //使用帮助
  },
  actions: {
    async getMenuList(state) {
      let data = await common
        .getData(configServer.API_URL + "portal/getResourceByToken", {}, "get")
        .then(res => {
          let menu = JSON.parse(res.result);
          menu = common
            .tree(menu)
            .map((i, index) => ({ ...i, menuItemIndex: index }));
          return menu;
        });
      state.commit("setMenuList", data);
    },
    async getFirstAppList({ commit }) {
      let data = await common
        .getData(
          `${configServer.API_URL}portal/getGcResourceByToken`,
          {},
          "get"
        )
        .then(res => {
          return JSON.parse(res.result).map(i => ({
            ...i,
            menuItemIndex: i.index
          }));
        });
      commit("getFirstAppList", data);
    },
    getBtnList(state) {
      common
        .getData(
          configServer.API_URL + "portal/getButtonCodeByToken",
          {},
          "get"
        )
        .then(res => {
          let menu = JSON.parse(res.result);
          state.commit(
            "setBtnList",
            menu.map(i => {
              return i.buttonCode;
            })
          );
        })
        .catch(e => {});
    },
   async  getUseHelpPage({commit}){
     await common.getData(configServer.API_URL + "portal/usingHelp/getResources",
      {},
      "get").then(res => {
        commit("setUseHelpPage", res.result)
      })
    },
    clear(state) {
      state.commit("clear");
    },
    //BI
    async getPermissionCity({ commit }) {
      const res = await API.userCityList();
      const { data, code, desc } = res;
      if (code === 200) {
        commit("setPermissionCity", data);
      } else {
        Message.error(desc);
      }
    }
  },
  mutations: {
    setMenuList(state, list) {
      state.menuList = list;
    },
    getFirstAppList(state, list) {
      state.firstAppList = list;
    },
    setBtnList(state, list) {
      state.btnList = list;
    },
    clear(state) {
      state.menuList = [];
      state.btnList = [];
    },
    setToUserCenter(state, bool) {
      state.toUserCenter = bool;
    },
    // BI
    setPermissionCity(state, data) {
      state.permissionCity = data;
      state.mCity = data[0].children[0].city_id;
    },
    setCityId(state, data) {
      state.areaId = data.areaId;
      localStorage.areaId = data.areaId;
      state.cityId = data.cityId;
      localStorage.cityId = data.cityId;
    },
    //商户列表
    setAgentlist(state, data) {
      localStorage.setItem("agentlist", JSON.stringify(data));
      state.agentlist = data;
    },
    setCurrentAgent(state, data) {
      localStorage.setItem("currentAgent", JSON.stringify(data));
      state.currentAgent = data;
    },
    //使用帮助页面
    setUseHelpPage(state, data) {
      state.useHelpPage = data
    }
  },
  getters: {
    getFirstMenuList: state => {
      const list = state.firstAppList.length
        ? state.firstAppList
        : state.menuList.slice(0, 8);
      let homePage = {};
      const otherPage = list.filter(i => {
        if (i.name === "首页") {
          homePage = i;
        }
        return i.name !== "首页";
      });
      return [homePage, ...otherPage];
    },
    getAgentlist: state => {
      const localStorageList = JSON.parse(localStorage.getItem("agentlist"));
      const list = state.agentlist.length ? state.agentlist : localStorageList;
      return list.map(i => ({ value: i.id, label: i.shortName }));
    },
    getCurrentAgent: state => {
      const data = JSON.parse(localStorage.getItem("currentAgent"));
      return Object.keys(state.currentAgent).length ? state.currentAgent : data;
    },
    useHelpPage:state => {
      return state.useHelpPage
    },
    btnCodeList:state =>  state.btnList
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js